import { render, staticRenderFns } from "./ExceptionAdd.vue?vue&type=template&id=352e5242&scoped=true&"
import script from "./ExceptionAdd.vue?vue&type=script&lang=js&"
export * from "./ExceptionAdd.vue?vue&type=script&lang=js&"
import style0 from "./ExceptionAdd.vue?vue&type=style&index=0&id=352e5242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352e5242",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
